<div class="pages-body flex flex-column cust-height">
    <div class="align-self-center mb-auto" style="width: 350px;">
        <div class="pages-panel card flex flex-column">       
            <div class="col-12">
                <span>{{'Pass_Init' | translate}}</span>
            </div>
            <div class="col-12">
                <span class="p-float-label">
                    <input
                        pInputText
                        [(ngModel)]="passWordOld"
                        type="password"
                        autofocus
                        name="passWord"
                        autocomplete="off"
                        class="p-inputtext p-component"
                    />
                    <label>{{'Pass_Old' | translate}}</label>
                </span>
            </div>
            <div class="col-12">
                <span class="p-float-label">
                    <input
                        pInputText
                        [(ngModel)]="passWord"
                        type="password"
                        autofocus
                        name="passWord"
                        autocomplete="off"
                        class="p-inputtext p-component"
                    />
                    <label>{{'Pass_New' | translate}}</label>
                </span>
            </div>
            <div class="col-12">
                <span class="p-float-label">
                    <input
                        pInputText
                        [(ngModel)]="passWordConf"
                        type="password"
                        autofocus
                        name="passWord"
                        autocomplete="off"
                        class="p-inputtext p-component"
                    />
                    <label>{{'Pass_Conf' | translate}}</label>
                </span>
            </div>
            <div class="col-12">
                <button
                    pButton
                    type="button"
                    label="{{'Send' | translate}}"
                    (click)="checkPassWrd()"
                    class="p-button p-component"
                ></button>
            </div>
        </div>
    </div>
</div>

